/**
 * Preferenze di **questo dispositivo**, non del profilo.
 *
 * Sono due, e sono entrambe scelte di accessibilità: il suono di chiamata e le
 * scorciatoie da tastiera. Stanno nel dispositivo e non sul server perché
 * riguardano com'è fatto questo posto — un ufficio in cui il volume dà
 * fastidio, una tastiera su cui Maiusc+C parte per sbaglio — e non chi è
 * entrato.
 *
 * L'archiviazione può essere negata (finestra privata, impostazioni del
 * browser): in quel caso la preferenza vale per questa sessione, e non è un
 * errore da mostrare a nessuno.
 */

export type Preference = 'console.sound' | 'console.shortcuts';

export function preferenceEnabled(key: Preference): boolean {
  try {
    return globalThis.localStorage?.getItem(key) !== 'off';
  } catch {
    return true;
  }
}

export function setPreference(key: Preference, enabled: boolean): void {
  try {
    globalThis.localStorage?.setItem(key, enabled ? 'on' : 'off');
  } catch {
    // Vale per questa scheda.
  }
}
